import React, { useState } from 'react';
import { useSelector, useDispatch, RootStateOrAny } from 'react-redux';
import {
  Container,
  Draggable,
  OnDropCallback,
  DropResult,
} from 'react-smooth-dnd';
import { arrayMoveImmutable } from 'array-move';
import { Tooltip } from '@material-ui/core';
import { ListActiveIntegrations } from '~/interfaces/integrations';
import { CallerInsights } from '~/components/Integrations';
import * as actionTypes from '~/store/actions/actionTypes';
import * as lib from '~/dependencies';
import {
  Accordion,
  AccordionSummary,
  AccordionBase,
  AccordionDetails,
  Avatar,
  Typography,
} from './styles';

export default function MovablePreference({ callId }: { callId: string }) {
  const dispatch = useDispatch();
  const { t } = lib.useTranslation();

  const [viewIntegrationId, setViewIntegrationId] = useState(undefined);

  const connectedIntegrations: ListActiveIntegrations = useSelector(
    (state: RootStateOrAny) => state.integrations?.accountIntegrations
  );

  const onDrop = ({ removedIndex, addedIndex }: DropResult) => {
    if (removedIndex !== null && addedIndex !== null) {
      const connectedIntegrationsSorted = arrayMoveImmutable(
        connectedIntegrations,
        removedIndex,
        addedIndex
      );

      if (localStorage && connectedIntegrationsSorted?.length) {
        localStorage.setItem(
          'LocalIntegrationsPreference',
          JSON.stringify(connectedIntegrationsSorted)
        );
      }

      dispatch({
        type: actionTypes.UPDATE_INTEGRATIONS_ORDER_PREFERENCE,
        payload: connectedIntegrationsSorted,
      });
    }
  };

  return (
    <Accordion expanded>
      <AccordionSummary id={callId} aria-controls={callId}>
        <AccordionBase>
          <Typography>
            {t('components.activeCalls.integrationAccordion.integration')}
          </Typography>

          <Container
            orientation="horizontal"
            behaviour="contain"
            style={{ zIndex: 500 }}
            onDrop={onDrop as OnDropCallback}
            onDragStart={() => setViewIntegrationId(undefined)}>
            {connectedIntegrations?.map(
              ({ id: integrationId, name, logo }, index) => (
                <Draggable
                  key={integrationId}
                  // @ts-ignore
                  onClick={() => setViewIntegrationId(integrationId)}>
                  <Tooltip title={name}>
                    <Avatar
                      className="draggable-item-horizontal"
                      animate={
                        viewIntegrationId
                          ? index ===
                            connectedIntegrations.findIndex(
                              e => e.id === viewIntegrationId
                            )
                          : index === 0
                      }
                      key={integrationId}
                      alt={name}
                      src={logo}>
                      {name}
                    </Avatar>
                  </Tooltip>
                </Draggable>
              )
            )}
          </Container>
        </AccordionBase>
      </AccordionSummary>
      <AccordionDetails>
        <CallerInsights
          key={callId}
          callId={callId}
          viewIntegrationId={viewIntegrationId}
        />
      </AccordionDetails>
    </Accordion>
  );
}
